import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { error } from 'pdf-lib';
import { debounceTime, forkJoin, map, Subject } from 'rxjs';
import { BillingStatus } from 'src/app/enums/enums';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { AddonService } from 'src/app/services/core/addons/addon.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { BillingService } from 'src/app/services/core/billing/billing.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { PlacetypesService } from 'src/app/services/core/placetypes/placetypes.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { TripService } from 'src/app/services/core/trip/trip.service';
import { sweetAlert } from 'src/app/utils/swal';
import { onTimeChange, phoneNumberLengthValidator, roundUp, timeZone } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-adjustment-form',
  templateUrl: './adjustment-form.component.html',
  styleUrls: ['./adjustment-form.component.css']
})
export class AdjustmentFormComponent {
  addMemberModalObj = false;
  addonsList: any = [];
  levelOfServiceList: any = [];
  preLevelOfServiceList: any = [];
  memberList: any = [];
  selectedMember: any = '';
  modifierList: any = [];
  newTripForm!: FormGroup;
  eventForm!: FormGroup;
  spaceTypeList: any = [];
  spaceTypeMainList: any = [];
  preSpaceTypeList: any = [];
  preAppointmentTypes: any = {};
  submitted = false;
  tripPurposeList: any = [];
  appointmentTypes: any = [];
  user: any;
  todayDate: any;
  tripId: any;
  StandingOrderId: any
  addMember: boolean = false;
  timeZone = timeZone;
  selectedDay: any = [];
  fundingSourceList: any = [];
  preFundingSource: any = {}
  preServiceAreaList: any = {}
  preMemberList: any = {}
  preAddons: any = {}
  serviceAreaList: any = [];
  memberPageNumber = 1;
  memberSearchPageNumber = 1;
  companies: any
  preCompanies: any
  placetypes: any;
  isWillCall: boolean[] = [];
  private readonly memberSearchSubject = new Subject<string | undefined>();
  memberSearchQuery: any;
  @Output() dataLoaded = new EventEmitter<void>();
  preferedTps: any = [];
  companyList: any = [];
  driverList: any = [];
  vehicleList: any = [];
  events: any = [];
  mapObj: any;
  isFromBilling = false;
  isDetailModal = false;
  tripData: any;
  fareDetails:any;
  fareCancelDetails:any;

  constructor(
    private fb: FormBuilder,
    private uploadService: UploadService,
    private sharedDataService: SharedDataService,
    private SpaceTypeService: SpaceTypeService,
    private levelOfService: LosService,
    private memberService: MemberService,
    private tripService: TripService,
    private router: Router,
    private appointmentType: AppointmentTypeService,
    private addonService: AddonService,
    private serviceArea: ServiceAreasService,
    private fundingSource: FundingSourceService,
    private activatedRoute: ActivatedRoute,
    private placetypesService: PlacetypesService,
    private cdr: ChangeDetectorRef,
    private credentialService: CredentialService,
    private billingService: BillingService
  ) {
  }

  get form() {
    return this.newTripForm.controls;
  }

  get eventsArray() {
    return this.eventForm.get('events') as FormArray;
  }

  get pickUpForm() {
    return this.newTripForm.controls.pickup as FormGroup;
  }

  get dropOffForm() {
    return this.newTripForm.controls.destination as FormGroup;
  }

  get addonsForm(): FormArray {
    return this.newTripForm.get('addons') as FormArray;
  }

  get addonsFormGroups(): FormGroup[] {
    return this.addonsForm.controls as FormGroup[];
  }

  get attachmentForm() {
    return this.newTripForm.get('attachments') as FormArray;
  }

  get attachmentFormGroups(): FormGroup[] {
    return this.attachmentForm.controls as FormGroup[];
  }

  ngOnInit(): void {

    if (this.activatedRoute.snapshot.url[0].path === 'billing') {
      this.isFromBilling = true;
    }
    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
      if (param && param['id'])
        this.tripId = param['id']
    })

    this.newTripForm = this.createForm();
    this.eventForm = this.createEventForm();
    this.makeCompulsoryCalls();
    // this.listenMemberSearch();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
    ];

    // Make all requests in parallel
    forkJoin(requests).pipe(untilDestroyed(this)).subscribe(
      ([res1, res2]) => {
        if (res2) {
          this.spaceTypeMainList = res2.filter((spaceType: any) => spaceType.isActive === true);
          this.preSpaceTypeList = this.spaceTypeMainList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        if (res1) {
          const activeSpaceTypeLosIds = this.spaceTypeMainList
            .filter((spaceType: any) => spaceType.isActive)
            .map((spaceType: any) => spaceType.los);
          this.levelOfServiceList = res1.filter((los: any) => los.isActive === true);

          this.levelOfServiceList = res1.filter((los: any) => los.isActive && activeSpaceTypeLosIds.includes(los.id)
          );
          this.preLevelOfServiceList = this.levelOfServiceList.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
        this.getUser();
        // Rest API calls here
        this.getServiceArea();
        this.getFundingSource();
        this.getAppointmentTypes();
        this.getPlaceTypes();
        this.getAllAddons();
        this.getCompanyWiseDrivers();
        this.getCompanyWiseVehicles();
        // this.getAllMembers();



        if (this.tripId && this.isFromBilling) {
          this.getBillingTripDetails();
        } else {
          this.getTripDetails();
        }
        this.getTripEvents();
        this.dataLoaded.emit();
      },
      (error: any) => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getTripDetails() {
    this.tripService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {

        this.tripData = data;
        this.fareDetails = this.tripData.offeredFare?.breakdown || {};
        this.fareCancelDetails = this.tripData.offeredFare?.cancelBreakdown || {};

        if (this.tripId) {
          this.getMemberById(data.member)
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
          additionalPassenger: data.additionalPassenger ?? '',
          driver: data.driver,
          vehicle: data.vehicle,
          association: data.association

        });
         this.newTripForm.get('suffix')?.setValue(data.suffix);
        this.addAttachment(data.attachments);
        this.onSelectLOS(data.levelOfService);
        this.addAddonsItem(data.addons);
        // this.memberSearch(null, data.member);
        // this.disableBillingFields();
      }
    })
  }

  getBillingTripDetails() {
    this.billingService.getTripById(this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {

        this.fareDetails = data.offeredFare?.breakdown || {};
        this.fareCancelDetails = data.offeredFare?.cancelBreakdown || {};

        if (this.tripId) {
          this.getMemberById(data.member)
        }

        this.newTripForm.patchValue({
          ...data,
          pickup: data.pickup,
          destination: data.destination,
          additionalPassenger: data.additionalPassenger ?? '',
          driver: data.driver,
          vehicle: data.vehicle,
        });
        this.tripData = data;
        this.addAttachment(data.attachments);
        this.onSelectLOS(data.levelOfService);
        this.addAddonsItem(data.addons);
        // this.memberSearch(null, data.member);
        // this.disableBillingFields();
      }
    })
  }

  getMemberById(id: any) {
    this.memberService.getMemberById(id).subscribe((data) => {
      if (data) {
        this.selectedMember = data;
      }
    })
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;
        this.todayDate = moment();
        this.newTripForm.patchValue({
          pickup: { time: this.todayDate.toISOString() },
          destination: { time: moment(this.todayDate).add(1, 'hours').toISOString() },
          company: data.company.id
        });
      }

    })
  }

  getAllMembers() {
    const queryParams: any = {
      limit: 10,
      page: this.memberPageNumber,
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.getPickerMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberPageNumber += 1;
        this.preMemberList = this.memberList.reduce((acc: any, item: any) => {
           acc[item.id] = item;
          return acc;
        }, {});
      }
    })
  }
  getServiceArea() {
    this.serviceArea.getPicker({ isActive: true }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.serviceAreaList = data.results;
        this.preServiceAreaList = this.serviceAreaList.reduce((acc: any, item: any) => {
          acc[item.id] = item;
          return acc;
        }, {});
      }
    })
  }

  getFundingSource() {
    this.fundingSource.getPicker({ isActive: true, limit: "999" }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSourceList = data.results;
        this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getPlaceTypes() {
    this.placetypesService.getPickers({ isActive: true }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.placetypes = data.results;
      }
    })
  }

  getLevelOfService() {
    return this.levelOfService.getPicker({ isActive: true, limit: 9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  getSpaceTypeList() {
    return this.SpaceTypeService.getPicker({ isActive: true, limit: 9999 }).pipe(
      map((res: any) => res.results || [])
    );
  }

  getCompanyWiseDrivers() {
    let queryParams = {
      limit: 9999,
      company: this.newTripForm.value.company,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPickerDrivers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.driverList = data.results;

      }
    })
  }
  getCompanyWiseVehicles() {
    let queryParams = {
      limit: 9999,
      company: this.newTripForm.value.company,
      isActive: true,
      isApproved: true
    }
    this.credentialService.getPickerVehicles(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.vehicleList = data.results;
      }
    })
  }

  getTripEvents() {
    const queryParam: any = {
      limit: 9999
    }

    if (this.isFromBilling) {
      queryParam.billing = this.tripId;
    } else {
      queryParam.trip = this.tripId;
    }

    this.tripService.getPickerTripEvents(queryParam)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.events = data.results.sort(
            (a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime()
          );
          // Build FormArray dynamically
          const eventFGs = this.events.map((e: any) =>
            this.fb.group({
              status: [e.status],
              trip: [e.trip],
              latitude: [e.latitude],
              longitude: [e.longitude],
              time: [e.time],
              id:[e.id]
            })
          );

          const eventFormArray = this.fb.array(eventFGs);
          this.eventForm.setControl('events', eventFormArray);

          console.log(this.eventForm.value);
        }
      });
  }

  sortEventsByTime() {
    const sorted = this.eventsArray.value.sort(
      (a: any, b: any) => new Date(a.time).getTime() - new Date(b.time).getTime()
    );
    this.eventsArray.clear();
    sorted.forEach((evt: any) => {
      this.eventsArray.push(this.fb.group(evt));
    });
  }

  getAllAddons() {
    const queryParams = {
      status: true,
      limit: 999,
    }
    this.addonService.getPickerAddons(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data.results) {
        this.addonsList = data.results.filter((addons: any) => addons.isActive === true);
          this.preAddons = this.addonsList.reduce((acc: any, item: any) => {
          const key = item.id || item._id;
          acc[key] = item;
          return acc;
        }, {});

      }
    })
  }


  onAdjustTrip() {
    this.submitted = true;
    if (this.newTripForm.invalid) return;
    const payload = this.newTripForm.getRawValue();

    if (payload.pickup.phoneNumber === '') {
      delete payload.pickup.phoneNumber
    }
    if (payload.destination.phoneNumber === '') {
      delete payload.destination.phoneNumber
    }
    if (payload.serviceArea === '') {
      delete payload.serviceArea
    }

    // if (this.isFromBilling){
    //   payload.billing = this.tripId
    // }else{
    //   payload.trip = this.tripId
    // }
    // const events = this.eventForm.value.events;
    // if(this.isFromBilling){
    //   payload.billing = this.tripId
    //   delete payload.trip
    // }
    if (this.isFromBilling) {
      payload.billingStatus = BillingStatus.RESUBMIT
    }

    if (!this.isFromBilling) {
      payload.trip = this.tripId
    }


    if (!payload.vehicle || payload.vehicle === "null") {
      payload.vehicle = null
    }
    
    if (!payload.driver || payload.driver === "null") {
      payload.driver = null
    }
 
    if (!payload.fare || payload.fare === "null") {
      payload.fare = null
    }
    
    if (!payload.offeredFare || payload.offeredFare === "null") {
      payload.offeredFare = null
    }


    this.billingService.adjustTrip(payload, this.isFromBilling, this.tripId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.id) {
        const events = this.eventForm.value.events.map((event: any) => ({ ...event, trip: null, billing: data.id,company:this.user.company.id }));
        this.billingService.bulkAdjustEvents(events).pipe(untilDestroyed(this)).subscribe((res: any) => {
           if (res) {
            if (!this.isFromBilling){
            this.router.navigate(['trips'], { fragment: data.status });
            }else{
              this.router.navigateByUrl('billing');
            }
          }
        });
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "Ok");
    }
    );
  }


  onSelectLOS(losId: any) {
    if (!losId) {
      this.spaceTypeList = [];
      this.newTripForm.patchValue({ spaceType: '' });
      return;
    }
    this.spaceTypeList = this.spaceTypeMainList.filter((item: any) => item.los === losId);
    if (!this.spaceTypeList.some((item: any) => item.id === this.newTripForm.value.spaceType)) {
      this.newTripForm.patchValue({ spaceType: '' });
    }
  }

  onSelectFundingSource(evt: any) {

  }

  // onSelectMember(event: any) {
  //   if (typeof event === 'string') {
  //     this.selectedMember = event ? this.memberList.find((m: any) => m.id === event) : null;
  //   } else {
  //     this.selectedMember = event ? this.memberList.find((m: any) => m.id === event.id) : null;
  //   }
  //   if (!this.selectedMember) {
  //     this.clearMemberData();
  //     return;
  //   }
  //   const memberFundingSourceId = (this.selectedMember.fundingSource ? this.selectedMember?.fundingSource : this.selectedMember.fundingsource) || ''
  //   if (this.selectedMember) {
  //     this.newTripForm.patchValue({
  //       ...this.selectedMember,
  //       fundingsource: memberFundingSourceId,
  //       pickup: {
  //         phoneNumber: this.selectedMember.contactNumber,
  //         address: this.selectedMember.address
  //       }
  //     })
  //     const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
  //       return area.zipCodes.includes(this.selectedMember?.address?.zipCode);
  //     });
  //     this.newTripForm.patchValue({
  //       serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
  //     });
  //     this.onSelectLOS(this.selectedMember.levelOfService)
  //   } else {
  //     this.newTripForm.patchValue({
  //       member: '',
  //       pickup: {
  //         time: '',
  //         placeName: '',
  //         phoneNumber: '',
  //         address: {
  //           name: '',
  //           coords: '',
  //           city: '',
  //           state: '',
  //           zipCode: '',
  //           floor: '',
  //           aptSuiteRoom: '',
  //         }
  //       },
  //       appointmentType: '',
  //       levelOfService: '',
  //       spaceType: '',
  //       privateNotes: '',
  //       generalNotes: '',
  //     });
  //   }
  // }

  clearMemberData() {
    this.newTripForm.patchValue({
      member: '',
      fundingsource: '',
      serviceArea: '',
      pickup: {
        placeName: '',
        phoneNumber: '',
        address: {
          name: '',
          coords: '',
          city: '',
          state: '',
          zipCode: '',
          floor: '',
          aptSuiteRoom: '',
        }
      },
      appointmentType: '',
      levelOfService: '',
      spaceType: '',
      privateNotes: '',
      generalNotes: '',
    });
    this.selectedMember = null;
  }


  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null);
    if (fileInput) {
      fileInput.value = '';
    }
  }

  onSelectAddonItem(addonItem: any) {
    if (!addonItem.value.addonId || !addonItem.value.quantity) return;

    const item = this.addonsList.find((item: any) => item._id === addonItem.value.addonId);
    addonItem.patchValue({
      ...item,
      total: item.fare * addonItem.value.quantity
    });
  }

  quantityGreaterThanZero(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }
    const numberValue = Number(value);
    return numberValue > 0 ? null : { greaterThanZero: true };
  }


  removeAddonsItem(index: any) {
    const items = this.newTripForm.get('addons') as FormArray;
    items.removeAt(index);
  }

  addAddonsItem(preAddonList?: any) {
    const items = this.newTripForm.get('addons') as FormArray;

    if (preAddonList) {
      for (const addon of preAddonList) {
        items.push(
          this.fb.group({
            addon: [addon.addon, Validators.required],
            quantity: [addon.quantity, [Validators.required, this.quantityGreaterThanZero]],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    items.push(
      this.fb.group({
        addon: ['', Validators.required],
        quantity: [1, [Validators.required, this.quantityGreaterThanZero]],
      })
    );
    // }
  }

  createForm(): FormGroup {
    return this.fb.group({
      member: ['', Validators.required],
      pickup: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[], Validators.required],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        })
      }),
      destination: this.fb.group({
        time: ['', Validators.required],
        placeName: [''],
        phoneNumber: ['', [phoneNumberLengthValidator]],
        address: this.fb.group({
          name: ['', Validators.required],
          coords: [[], Validators.required],
          city: [''],
          state: [''],
          zipCode: [''],
          floor: [''],
          aptSuiteRoom: [''],
        })
      }),
      appointmentType: [''],
      levelOfService: ['', Validators.required],
      spaceType: ['', Validators.required],
      miles: [''],
      additionalPassenger: [''],
      privateNotes: [''],
      generalNotes: [''],
      requesterName: [''],
      attachments: this.fb.array([]),
      reference: [''],
      suffix: [''],
      addons: this.fb.array([]),
      fundingsource: ['', Validators.required],
      serviceArea: [''],
      company: [''],
      driver: [null],
      vehicle: [null],
      distance: [''],
      duration: [''],
      trip: [''],
      status: [''],
      fare: [null],
      offeredFare: [null],
      specialRate: [''],
      association: [''],
      signature: [''],
      billingNotes: ['']
    });
  }

  createEventForm(): FormGroup {
    return this.fb.group({
      events: this.fb.array([]),
    });
  }


  setOriginAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';
    const matchedServiceArea = this.serviceAreaList?.find((area: any) => {
      return area.zipCodes.includes(zip);
    });
    if (index != 0) {
      this.newTripForm.patchValue({
        serviceArea: matchedServiceArea ? matchedServiceArea.id : ''
      });
    }
    this.newTripForm.patchValue({
      pickup: {
        address: {
          city: cityName,
          state: stateName,
          zipCode: zip,
          name: place.formatted_address,
          coords: [
            place.geometry.location.lng(),
            place.geometry.location.lat()
          ]
        }
      }
    });
    this.calculateMiles(index);
  }

  setDestinationAddress(place: any, index?: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    // const zip = selectedAddress.zipCode;
    const zipCode = selectedAddress.find((data: any) =>
      data.types.includes('postal_code')
    );
    const zip = zipCode ? zipCode.long_name : '';


    this.newTripForm.patchValue({
      destination: {
        address: {
          city: cityName,
          state: stateName,
          zipCode: zip,
          name: place.formatted_address,
          coords: [
            place.geometry.location.lng(),
            place.geometry.location.lat()
          ]
        }
      }
    });
    this.calculateMiles(index);
  }

  onPickupDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
    this.newTripForm.patchValue({
      destination: {
        time: moment(controlName?.value).add(1, 'hour').toISOString()
      }
    })
  }

  jobAcceptedDateChange(controlName: AbstractControl<any, any> | null) {
    console.log("Control check", controlName);
    onTimeChange(controlName);
  }

  jobArrivedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobStartedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobCompletedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobFinishedDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  jobCancelledDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName);
  }

  getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.appointmentTypes = data.results
        this.preAppointmentTypes = this.appointmentTypes.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }


  addAttachment(preAttachments?: any) {
    const attachments = this.newTripForm.get('attachments') as FormArray;
    if (preAttachments) {
      for (const attachment of preAttachments) {
        attachments.push(
          this.fb.group({
            filename: [attachment.filename, Validators.required],
            url: [attachment.url, Validators.required],
            mimeType: [attachment.mimeType],
          })
        );

      }
      return;
    }

    // if (!items.invalid) {
    attachments.push(
      this.fb.group({
        filename: ['', Validators.required],
        url: ['', Validators.required],
        mimetype: [''],
      })
    );
  }

  uploadAttachment(event: any) {
    const fileInput = event.target
    const file = fileInput.files?.[0];

    if (file && file.size > 1024 * 1024) { // 1MB = 1024 * 1024 bytes
      sweetAlert('File too large', 'Please upload a file smaller than 1MB.', 'warning', 'OK');
      return;
    }

    this.uploadService.uploadTripAttachment(event.target.files[0]).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        const file = event.target.files[0];
        if (file) {
          const fileData = {
            filename: file.name,
            mimeType: file.type,
            url: data.fileUrl
          };
          this.attachmentForm.push(this.fb.control(fileData));
        }
        fileInput.value = '';
      }
    })
  }

  removeAttachment(index: number) {
    this.attachmentForm.removeAt(index);
  }

  isAddressInvalid(nameControl: AbstractControl | null, coordsControl: AbstractControl | null): boolean {
    const nameInvalid = !!nameControl?.errors?.['required'];
    const coords = coordsControl?.value;

    const coordsInvalid =
      !coords || // null, undefined, or empty string
      (Array.isArray(coords) && coords.length === 0) || // empty array
      (typeof coords === 'object' && !Array.isArray(coords) && Object.keys(coords).length === 0); // empty object

    return nameInvalid || coordsInvalid;
  }



  openAddMemberModal() {
    this.addMember = true;
  }

  onSaveMember(evt: any) {
    if (evt && this.memberList && this.memberList.length) {
      // Update existing member in the list
      const index = this.memberList.findIndex((member: any) => member.id === evt.id);
      if (index !== -1) {
        this.memberList[index] = evt; // Update existing member
        this.memberList = [...this.memberList];
      } else {
        this.memberList.push(evt); // Add new member if not exists (fallback)
      }

      // Update the form with new member details
      this.newTripForm.patchValue({
        member: evt.id
      });
      // this.onSelectMember(evt);

      this.addMemberModalObj = false;

      // Refresh the dropdown by triggering change detection
    }


  }


  calculateMiles(index?: number) {
    let queryParam;
    let startCoords: any = [];
    let endCoords: any = [];

    startCoords = this.pickUpForm.value.address.coords;
    endCoords = this.dropOffForm.value.address.coords;

    if (startCoords.length && endCoords.length) {
      queryParam = {
        start: [startCoords[0], startCoords[1]].toString(),
        end: [endCoords[0], endCoords[1]].toString(),
      };

      this.tripService
        .calculateMiles(queryParam)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.cdr.detectChanges();
              const firstSegment =
                data.features[0]?.properties?.segments[0]?.distance || 0;
              const milesValue = Number((firstSegment / 1609.344).toFixed(2));
              this.newTripForm.patchValue({ miles: roundUp(milesValue) });
            }
          },
          error: (err) => {
            this.cdr.detectChanges();
            sweetAlert('Error', 'Invalid Address', 'error', 'Ok');
          },
          complete: () => {
            // optional: code to run after the observable completes
            console.log('calculateMiles request completed');
          },
        });
    }
  }


  // onScroll() {
  //   if (this.memberSearchQuery) {
  //     this.memberSearch(this.memberSearchQuery);
  //   } else {
  //     this.getAllMembers();
  //   }
  // }

  onSearch(event: any) {
    const { term } = event;
    if (term) {
      this.memberSearchSubject.next(term);
    } else {
      this.clearSearh();
    }
  }

  listenMemberSearch() {
    this.memberSearchSubject
      .pipe(debounceTime(1000))
      .pipe(untilDestroyed(this)).subscribe((search) => {
        this.memberSearchQuery = search;
        if (search && search.length >= 3) {
          this.memberList = [];
          this.memberSearchPageNumber = 1;
          this.memberSearch(search);
        }
      });
  }

  memberSearch(search: any, id = null) {
    const queryParams: any = {
      limit: 10,
      page: this.memberSearchPageNumber
    }

    if (search) {
      queryParams.search = search;
    }

    if (id) {
      queryParams.id = id;
    }

    if (!this.tripId) {
      queryParams.isActive = true;
    }

    this.memberService.searchMembers(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.memberList = [...this.memberList, ...data.results];
        this.memberSearchPageNumber += 1;
      }
    });
  }


  setWillCall(event: any, index: number) {

    if (event.target.checked) {
      // Trigger UI refresh for checkbox binding
      this.isWillCall = [...this.isWillCall];
    } else {
      // Only uncheck current one
      this.isWillCall[index] = false;
      this.isWillCall = [...this.isWillCall];
    }
  }

  onClear() {
    if (this.memberSearchQuery) {
      this.clearSearh();
      this.clearMemberData();
    }
  }

 openMapModal(event?: any) {
    const hasData = event && typeof event === 'object' && Object.keys(event).length > 0;

    this.mapObj = hasData
      ? event
      : {
        company: this.newTripForm.value.company || '',
        latitude: 40.7128,
        longitude: -74.0060,
        status: '',
        trip: this.tripId || '',
        time: moment().toISOString(),
      };

  }

  onLocationChanged(locationData:any) {
    if (locationData) {
      const eventIndex = this.eventsArray.value.findIndex((event: any) =>
        event.status === locationData.status 
      );

      if (eventIndex !== -1) {
        // Update existing event
        const eventControl = this.eventsArray.at(eventIndex);
        if (eventControl) {
          eventControl.patchValue({...locationData
          });
          this.events[eventIndex] = locationData;
          this.cdr.detectChanges();
        }
      } else {
        // Add new event
        const newEvent = {
          ...locationData,
          company: this.mapObj.company
        };
        this.eventsArray.push(this.fb.group(newEvent));
        this.cdr.detectChanges();
      }
        this.sortEventsByTime();
    }
  }

  clearSearh() {
    this.memberSearchQuery = '';
    this.memberSearchPageNumber = 1;
    this.memberList = [];
    this.memberPageNumber = 1
    this.getAllMembers();
  }

  onClose() {
    if (!this.selectedMember && this.memberSearchQuery) {
      this.clearSearh();
    }
  }

  // disableBillingFields() {
  //   const controlsToDisable = [
  //     'member', 'spaceType', 'reference', 'levelOfService', 'serviceArea',
  //     'pickup', 'destination', 'addons', 'appointmentType', 'miles',
  //     'additionalPassenger', 'requesterName'
  //   ];

  //   controlsToDisable.forEach(key =>
  //     this.newTripForm.get(key)?.disable({ onlySelf: true })
  //   );

  //   // Disable Addons FormArray items as well
  //   this.addonsForm.controls.forEach((group: any) =>
  //     group.disable({ onlySelf: true })
  //   );
  // }

  opendetailModal() {
    this.isDetailModal = true;
  }

  getAddonDisplay(addonId: string): string {
  const addon = this.preAddons?.[addonId];
  return addon ? `${addon.title} - $${addon.fare}` : '—';
}

 onDeleteEvent(event:any,index: number) {
    sweetAlert('Warning', 'Are you sure you want to delete this event ?', 'warning', 'Yes', 'No').then((result) => {
      if (result.isConfirmed) {
        const events = this.eventForm.get('events') as FormArray;
        events.removeAt(index);
        this.events.splice(index, 1);

        if(this.isFromBilling) {
          this.tripService.deleteBillingEvents(event.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
            if (data) {
              sweetAlert('Success', 'Event deleted successfully', 'success', 'OK');
            }
          })
        }
      }
  
  })
}
  formatValue(value: any) {
    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
      return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }

    grandTotal(legA: any): number {
    const legATotal = Number(legA?.total || 0);
    return legATotal;
  }

}